// Capacity constraint: do not allocate more people than staffRequired for each event.
// Interface: (model, params) => Constraint[]
// model.optimizationIndexes must contain: users, events, staffRequired
export function buildCapacityConstraints(model, _params = {}) {
  const idx = model?.optimizationIndexes || {};
  const users = Object.keys(idx.users || {});
  const staffRequiredByRole = idx.staffRequiredByRole || {};
  const declared = new Set(Object.keys(idx.decisionVariables || {}));

  const constraints = [];
  // For each event and each role required, enforce per-role capacity
  for (const [eKey, rolesObj] of Object.entries(staffRequiredByRole)) {
    const roleKeys = Object.keys(rolesObj || {});
    for (const rKey of roleKeys) {
      const assignmentVars = users
        .map((uKey) => `x_${uKey}_${eKey}_${rKey}`)
        .filter((name) => declared.has(name));
      const vars = [...assignmentVars, `d_${eKey}_${rKey}`];
      const coeffs = vars.map(() => 1);
      const req = Number(rolesObj[rKey] ?? 0) || 0;
      constraints.push({ linear: { vars, coeffs }, domain: [req, req] });
    }
  }
  return constraints;
}
